import React from 'react';
import { compact } from 'lodash';

import { SidebarItems } from '@/modules/corporate/modules/admin/hooks/useSidebar';

import { NavMatchable, UnifiedNav } from '../types';

// Undefined makes the sidebar match on `href` alone.
const toRoutes = ({ href, matchPrefix, activeRoutes }: NavMatchable) => {
  if (activeRoutes) {
    return compact([href, ...activeRoutes]);
  }

  return matchPrefix || !href ? undefined : [href];
};

export function toSidebarItems(nav: UnifiedNav): SidebarItems {
  return nav.map((section) => ({
    id: section.id,
    children: section.items.map((item) => {
      const Icon = item.icon;

      return {
        id: item.id,
        text: item.label,
        badge: item.badge,
        icon: Icon ? <Icon className="h-18 w-18" strokeWidth={1.2} /> : undefined,
        to: item.href,
        enabled: true,
        isDisabled: item.isDisabled,
        routes: toRoutes(item),
        children: item.groups?.flatMap((group) =>
          group.items.map((subItem) => {
            const SubIcon = subItem.icon;

            return {
              id: subItem.id,
              text: subItem.label,
              icon: SubIcon ? <SubIcon className="h-18 w-18" strokeWidth={1.2} /> : undefined,
              to: subItem.href,
              enabled: true,
              isDisabled: subItem.isDisabled,
              routes: toRoutes(subItem),
              groupId: group.id,
            };
          }),
        ),
      };
    }),
  }));
}
